module.exports = __webpack_public_path__ + "img/clock-filled.07529271.svg";